module.exports = __webpack_public_path__ + "img/symbol_8.01f25a7f.png";